import { findMany, find, offset, hasClass, addClass, removeClass, on } from '../helpers';

// Define a function to handle the "Read More" functionality for a given container.
const handleReadMore = container => {
    // Check if the container has already been processed.
    if (container.bound) {
        return;
    }

    // Mark the container as processed to prevent duplicate processing.
    container.bound = true;

    // Find the button and body copy elements within the container.
    const button = find('[data-read-button]', container);

    let bodyCopy = find('[data-body-copy]', container);

    // Define a function to open the content when the button is clicked.
    const open = () => {
        // Check if the body copy is not already open.
        if (!hasClass(bodyCopy, 'open')) {
            // Add the 'open' class and remove the 'h-0' class to show the content.
            addClass(bodyCopy, 'open');
            removeClass(bodyCopy, 'h-0');
            bodyCopy.style.height = 'auto';

            // Use requestAnimationFrame for smoother animations.
            requestAnimationFrame(() => {
                const { height } = offset(bodyCopy);

                // Set the height to 0 to prepare for animation.
                bodyCopy.style.height = 0;
                addClass(button, ['opacity-0', 'pointer-events-none']);

                // Use another requestAnimationFrame for the height animation.
                requestAnimationFrame(() => {
                    // Set the final height to reveal the content.
                    bodyCopy.style.height = `${height}px`;

                    // Delay the removal of the button for a smooth transition.
                    setTimeout(() => {
                        button.remove();
                    }, 100);
                });
            });
        }
    }

    // Add a click event listener to the button to trigger the open function.
    on('click', open, button);
}

// Function to handle resizing the content
const resizeContent = () => {
    const containers = findMany('[data-read-more]');

    containers.forEach(container => {
        const bodyCopy = find('[data-body-copy]', container);

        if (hasClass(bodyCopy, 'open')) {
            // Remove the 'open' class and set the height to 'auto' for accurate measurement
            removeClass(bodyCopy, 'open');
            bodyCopy.style.height = 'auto';

            requestAnimationFrame(() => {
                const { height } = offset(bodyCopy);

                bodyCopy.style.height = `${height}px`;

                // Reapply the 'open' class to display the content
                requestAnimationFrame(() => {
                    addClass(bodyCopy, 'open');
                });
            });
        }
    });
}

// Find all elements with the 'data-read-more' attribute and apply the handleReadMore function to each.
findMany('[data-read-more]').forEach(handleReadMore);

// Add a resize event listener to update the content height
on('resize', resizeContent, window);
